import {cloneDeep, find} from "lodash";
export const DeploymentApplyController = ($scope,
                                           $mdDialog,
                                          $BoothList,
                                           callback,
                                            deployment,
                                            hasBooth) => {
    "ngInject";

    $scope.deployment = deployment;
    $scope.hasBooth = hasBooth;
    $scope.boothId = deployment.booth_id;
    $scope.boothDeployment = "";
    $scope.copiedBooth = cloneDeep(deployment.booth_id);
    $scope.boothsArray = [];

    $scope.apply = () => {
        callback({req:
                {deployment_url: deployment.url, booth_id: $scope.boothId},
                replace: {status: !!$scope.boothDeployment && $scope.boothId !== $scope.copiedBooth, from: $scope.boothDeployment, to: $scope.deployment.name, target: $scope.boothId},
                move: {status: $scope.hasBooth && $scope.boothId !== $scope.copiedBooth, from: $scope.copiedBooth, to: $scope.boothId, target: deployment.name},
                target: deployment.name

        });
        $mdDialog.hide();
    };
    $scope.closeDialog = () => {
        $mdDialog.hide();
    };
    $scope.loadBooths = () => {
        let booths = $BoothList.query();
        booths.$promise
            .then((data) => {
                $scope.boothsArray = data;
            })
            .catch((e) => { console.log(e); });

        return booths;
    };
    $scope.updateValue = (v) => {
        $scope.boothId = v;
        let installedBooth = find($scope.boothsArray, {booth_id: $scope.boothId});
        if (installedBooth.deployment) {
            $scope.boothDeployment = installedBooth.deployment.name;
        }
    };

    $scope.loadBooths();

};



// WEBPACK FOOTER //
// ./sources/components/deployments/deployment-apply/deployment-apply.js